import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('dateRangePicker');

    return {
        CLEAR: t('clear'),
        RESET: t('reset')
    };
};

export default useTranslation;
